import { Router } from '@angular/router';
import { MenuService } from './menu.service';
import { INavData } from '@coreui/angular';
import { Injectable } from '@angular/core';
import { InjectorInstance } from '../app.module';
import { AtecoCompanyType, CompanyDashboardStaticObject, CompanyDTO, CompanyListDTO, CompanyTypeEnum, DashBoardInfo, InfoPurchaseNamirialPayLink, RF19ControlTypeEnum } from '../models/company.model';
import { AuthService } from './auth.service';
import { Observable, Subject } from 'rxjs';
import { UserService } from './user.service';
import { DocumentFilterDTO } from '../models/documentFilter.model';
import { UserImpersonationsService } from '../services/user-impersonations.service';
import { DialogService } from './dialog.service';
import { TranslateService } from '@ngx-translate/core';
import { SPIDService } from './spid.service';
import { PortaleFEService } from './portaleFE.service';
import { NamirialpayService } from './namirialpay.service';
import { ReceiptFilterDTO } from '../models/receipt.model';

const SESSION_STORAGE_COMPANY_SELECTED_NAME: string = "fattureXlsSelectedCompany";
const LOCAL_STORAGE_i18nJSON_NAME: string = "fattureXlsI18n";
const SELECTED_LANGUAGE_JSON: string = "selectedLanguage";

@Injectable({
  providedIn: 'root'
})

export class GlobalService {

  private static currentCompany: CompanyListDTO = null;
  public static changeCurrentCompanyDisable: boolean = false;
  private static I18N_JSON: any = null;
  private static selectedLanguage: any = null;
  public static isDarkMode: boolean = null;
  public static authSpidOk: boolean = false;
  public static isLicenseInsideExpired: boolean = false;
  private static _authService: AuthService;
  private static _menuService: MenuService;
  private static _userImpersonationService : UserImpersonationsService;  
  public static SESSION_STORAGE_FILTER_DOCUMENT: string = "fattureXlsFilterDocument";
  public static SESSION_STORAGE_FILTER_ACTIVE_SCHEDULER: string = "fattureXlsFilterActiveScheduler";
  public static SESSION_STORAGE_FILTER_PASSIVE_SCHEDULER: string = "fattureXlsFilterPassiveScheduler";
  public static SESSION_STORAGE_FILTER_RECEIPTS: string = "fattureXlsFilterReceipts";
  
  private static _router: Router;
  public static currentManagedCompany: CompanyListDTO = null;
  public static navItems = new Array<INavData>();
  public static availableInvoicesPercentage: number = 0;
  public static companyDashboardStaticObject: CompanyDashboardStaticObject = new CompanyDashboardStaticObject();
  
  public static _userservice: UserService;
  private static _namirialpayservice: NamirialpayService;

  public static translate: TranslateService;
  private static spidService: SPIDService;
  private static portaleFEService: PortaleFEService;

  private subjectName = new Subject<any>(); //need to create a subject

  sendUpdate(message: string) { //the component that wants to update something, calls this fn
    this.subjectName.next({ text: message }); //next() will feed the value in Subject
  }

  getUpdate(): Observable<any> { //the receiver component calls this function
    return this.subjectName.asObservable(); //it returns as an observable to which the receiver funtion will subscribe
  }
  constructor( ) { 
    
  }
  
  public static generateRandomString(length: number): string {
  
     let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }

    return result;
  
  }
  
static getSessionStorageFilter(filterType: string=this.SESSION_STORAGE_FILTER_DOCUMENT):any
{
  let  filter:any;
  if (this.SESSION_STORAGE_FILTER_DOCUMENT== this.SESSION_STORAGE_FILTER_RECEIPTS)
  {
    let filter = new ReceiptFilterDTO();    
  }
  else
  {
    let filter = new DocumentFilterDTO();
  }
  
  let filterString = sessionStorage.getItem(filterType);
  if(filterString)
  {
    filter = JSON.parse(filterString);
    return filter;
  }
  else
  {
    return null;
  }
  
}

  static setSessionStorageFilter(filter : any, filterType: string=this.SESSION_STORAGE_FILTER_DOCUMENT) 
  {
    sessionStorage.setItem(filterType,JSON.stringify(filter));
  }
  
  /**
   * Restituisce la Company corrente, cioè quella selezionata nel menù a tendina della company sulla navbar.
   * Se non esiste nella variabile globale tenta di leggerlo dal sessionStorage altrimenti restituisce NULL
   */
  static getCurrentCompany(): CompanyListDTO {
    if (this.currentCompany != null && this.currentCompany != undefined)
      return this.currentCompany;
    else if (sessionStorage.getItem(SESSION_STORAGE_COMPANY_SELECTED_NAME) != null || localStorage.getItem(SESSION_STORAGE_COMPANY_SELECTED_NAME) != null) {
      let encodedCompany: string = sessionStorage.getItem(SESSION_STORAGE_COMPANY_SELECTED_NAME) != null ? sessionStorage.getItem(SESSION_STORAGE_COMPANY_SELECTED_NAME) : localStorage.getItem(SESSION_STORAGE_COMPANY_SELECTED_NAME);
      let decodedCompany = JSON.parse(atob(encodedCompany));
      this.setCurrentCompany(decodedCompany);
      return this.currentCompany;
    }
    // else {
    //   GlobalService._authService = InjectorInstance.get<AuthService>(AuthService);
    //   GlobalService._authService.logout();
    // }
  }

  /**
   * Memorizza l'ID della company gestita attualmente
   * @param id ID della company
   */
  static setCurrentCompany(company: CompanyListDTO) {
    
    this._userservice = InjectorInstance.get<UserService>(UserService);
    this.translate = InjectorInstance.get<TranslateService>(TranslateService);
    this.spidService = InjectorInstance.get<SPIDService>(SPIDService);
    this.portaleFEService = InjectorInstance.get<PortaleFEService>(PortaleFEService);        
    this._namirialpayservice = InjectorInstance.get<NamirialpayService>(NamirialpayService);        

    this.currentCompany = company;

    if (this.currentCompany != null && this.currentCompany != undefined) {
      this.FillStaticCompanyObject(this.currentCompany);      
      let encodedCompany: string = btoa(JSON.stringify(this.currentCompany));
      sessionStorage.setItem(SESSION_STORAGE_COMPANY_SELECTED_NAME, encodedCompany);
      localStorage.setItem(SESSION_STORAGE_COMPANY_SELECTED_NAME, encodedCompany);
    }
    else
      sessionStorage.removeItem(SESSION_STORAGE_COMPANY_SELECTED_NAME);

  }

  static RF19LoadInfo(checksales: number, checkcashed: number, sales: number, cashed:number, percsales:number, perccashed: number, limitoutnextyear: number, limitoutnow: number ) {
    if (limitoutnextyear != null) {
      this.companyDashboardStaticObject.RF19LimitOutNextYear = limitoutnextyear;
    }
    
    if (limitoutnow != null) {
      this.companyDashboardStaticObject.RF19LimitOutNow = limitoutnow;
    }
    
    this.companyDashboardStaticObject.RF19Sales = sales;
    this.companyDashboardStaticObject.RF19Cashed = cashed;
    this.companyDashboardStaticObject.RF19CheckSales = checksales;
    this.companyDashboardStaticObject.RF19CheckCashed = checkcashed;
    
    this.companyDashboardStaticObject.RF19CashedPercentage = perccashed;
    this.companyDashboardStaticObject.RF19SalesPercentage = percsales;  

  }

  static FillDashBoardInfo(anno: number, salesamount: number, cashedamount: number, dueamount: number, passiveamount: number, invoicetosend: number,  invoicetosenderror: number, invoicerejected: number) {
    
    this.companyDashboardStaticObject.DashBoardInfo = new DashBoardInfo();
    this.companyDashboardStaticObject.DashBoardInfo.Anno = anno;
    this.companyDashboardStaticObject.DashBoardInfo.Salesamount = salesamount;
    this.companyDashboardStaticObject.DashBoardInfo.Cashedamount = cashedamount;
    this.companyDashboardStaticObject.DashBoardInfo.Dueamount = dueamount;
    this.companyDashboardStaticObject.DashBoardInfo.Passiveamount = passiveamount;
    this.companyDashboardStaticObject.DashBoardInfo.InvoiceToSend = invoicetosend;
    this.companyDashboardStaticObject.DashBoardInfo.InvoiceToSendError = invoicetosenderror;
    this.companyDashboardStaticObject.DashBoardInfo.InvoiceRejected = invoicerejected;
    
  }

  static LoadDashBoardInfoFromUserService() { 

    this.companyDashboardStaticObject.DashBoardInfo = new DashBoardInfo();
    
    
    
      this._userservice.DashBoardInfo(this.getUsedCompany()).then((res) => {                            
        
        /**
        this.globalService.companyDashboardStaticObject.DashBoardInfo.Anno = res.Anno;
        this.globalService.companyDashboardStaticObject.DashBoardInfo.Cashedamount = res.Cashedamount;
        this.globalService.companyDashboardStaticObject.DashBoardInfo.Salesamount = res.Salesamount;
        this.globalService.companyDashboardStaticObject.DashBoardInfo.Passiveamount = res.Passiveamount;
        this.globalService.companyDashboardStaticObject.DashBoardInfo.Dueamount = res.Dueamount;
        this.globalService.companyDashboardStaticObject.DashBoardInfo.InvoiceToSend = res.InvoiceToSend;
        this.globalService.companyDashboardStaticObject.DashBoardInfo.InvoiceRejected = res.InvoiceRejected;            
        */
        this.FillDashBoardInfo(res.Anno,res.Salesamount,res.Cashedamount,res.Dueamount,res.Passiveamount,res.InvoiceToSend,res.InvoiceToSendError,res.InvoiceRejected);   
      })
    ;

  }

  static LoadInfoNamirialPayLinkPackage(fk_company: number) { 

    this.companyDashboardStaticObject.InfoPurchaseNamirialPayLink = new InfoPurchaseNamirialPayLink();
          
      this._namirialpayservice.NamirialPayLinkGetInfo(fk_company).then((res) => {           
        if (res !=undefined  && res != null) {      
            this.companyDashboardStaticObject.InfoPurchaseNamirialPayLink.LinkPurchased =  res.LinkPurchased;
            this.companyDashboardStaticObject.InfoPurchaseNamirialPayLink.LinkActive =  res.LinkActive;
            this.companyDashboardStaticObject.InfoPurchaseNamirialPayLink.LinkUsed =  res.LinkUsed;      
            this.companyDashboardStaticObject.InfoPurchaseNamirialPayLink.LinkSent =  res.LinkSent;
            this.companyDashboardStaticObject.InfoPurchaseNamirialPayLink.LinkAvailable =  res.LinkAvailable;
            this.companyDashboardStaticObject.InfoPurchaseNamirialPayLink.LinkRecoverable =  res.LinkRecoverable;
            this.companyDashboardStaticObject.InfoPurchaseNamirialPayLink.LinkPercent = res.LinkActive != 0 ? (res.LinkAvailable / res.LinkActive) * 100: 0;                      
           

            const existing = (this.companyDashboardStaticObject.ChildDetailProducts || [])
            .filter(p => p.ProductType !== 1);

            const incoming = res.DetailProducts || [];

            this.companyDashboardStaticObject.ChildDetailProducts = [...existing, ...incoming];
        };

      });

      

            
        
  }
      
  static FillStaticCompanyObject(company: CompanyListDTO) {

    if (company == null)
      return;
    
    //Contatore    
    this.companyDashboardStaticObject.ActiveInvoiceCounter = company.ActiveInvoiceCounter;
    this.companyDashboardStaticObject.PassiveInvoiceCounter = company.PassiveInvoiceCounter;
    
        
    //Logica Denomination
    this.companyDashboardStaticObject.Denomination = company?.Denomination !=
      null && company?.Denomination != '' ? company?.Denomination : (company?.Name !=
        null && company?.Name != '' && company?.Surname != null && company?.Surname !=
        '' ? company?.Name + ' ' + company?.Surname : '');
    this.companyDashboardStaticObject.vatnumber = company?.VatNumber != null && company?.VatNumber != '' ? company?.VatNumber : 
      (company?.FiscalCode != null && company?.FiscalCode != '' ? company?.FiscalCode : '');

    this.companyDashboardStaticObject.siret = company?.FR_Siret;
    
      //Logica Telefono
    this.companyDashboardStaticObject.Telephone = company?.Telephone != null &&
      company?.Telephone != '' ? company?.Telephone : '';
    //Logica Email
    this.companyDashboardStaticObject.Email = company?.Email != null &&
      company?.Email != '' ? company?.Email : '';
    this.companyDashboardStaticObject.LicenseValidFrom = company.LicenseValidFrom;
    this.companyDashboardStaticObject.LicenseValidTo = company.LicenseValidTo;
    
    //Logica CommercialProductInUse    
    this.companyDashboardStaticObject.CommercialProductInUse = company.FK_CommercialProductInUse == 4 ? this.translate.instant("GENERIC_LABEL.LICENSE_FLATRATE") : 
                                                               company.FK_CommercialProductInUse == 5 ? this.translate.instant("GENERIC_LABEL.LICENSE_TRIAL") : 
                                                               company.FK_CommercialProductInUse == 1 ? this.translate.instant("GENERIC_LABEL.LICENSE_STANDARD") : null;
    this.companyDashboardStaticObject.SKU = company.SKU;        
    
    if (company.CompanyType == CompanyTypeEnum.DESK && company.SKU != null ) {
      if (Number(this.companyDashboardStaticObject.SKU) >= 1080020048 && Number(this.companyDashboardStaticObject.SKU) <= 1080020054) {        
        this.companyDashboardStaticObject.CommercialProductInUse = this.translate.instant("GENERIC_LABEL.LICENSE_NON_EXPIRING_INVOICES");
      }
      else if (this.companyDashboardStaticObject.SKU != "") {
        this.companyDashboardStaticObject.CommercialProductInUse = this.translate.instant("GENERIC_LABEL.LICENSE_UNLIMITED");
      }
    }
    
    this.companyDashboardStaticObject.LastLoginDate = company.LastLoginDate;
    this.companyDashboardStaticObject.RemainingInvoices = company.RemainingInvoices;
    this.companyDashboardStaticObject.PackageQuantity = company.PackageQuantity;
    this.companyDashboardStaticObject.ChildDetailProducts = company.ChildDetailProducts;
    this.companyDashboardStaticObject.AuthSPID = company.AuthSPID;
    this.companyDashboardStaticObject.CompanyType = company.CompanyType;
    this.companyDashboardStaticObject.MyNamirialPurchaseAccount = company.MyNamirialPurchaseAccount;
    
    // Limiti Regime Forfettario    
    this.companyDashboardStaticObject.FK_TaxRegime = company.FK_TaxRegime;                 
    this.companyDashboardStaticObject.RF19LimitOutNextYear = company.RF19LimitOutNextYear;
    this.companyDashboardStaticObject.RF19LimitOutNow = company.RF19LimitOutNow;
    this.companyDashboardStaticObject.RF19Sales = company.RF19Sales;
    this.companyDashboardStaticObject.RF19Cashed = company.RF19Cashed;
    this.companyDashboardStaticObject.RF19CheckSales = company.RF19CheckSales;
    this.companyDashboardStaticObject.RF19CheckCashed = company.RF19CheckCashed;            
    this.companyDashboardStaticObject.RF19ControlType = company.RF19ControlType;
    this.companyDashboardStaticObject.RF19CashedPercentage = company.RF19CashedPercentage;
    this.companyDashboardStaticObject.RF19SalesPercentage = company.RF19SalesPercentage;    

    this.availableInvoicesPercentage = 50;        
        
    if (this.companyDashboardStaticObject.PackageQuantity != null && this.companyDashboardStaticObject.PackageQuantity > 0 && this.companyDashboardStaticObject.RemainingInvoices != null) {      
      this.availableInvoicesPercentage = Math.round((this.companyDashboardStaticObject.RemainingInvoices / this.companyDashboardStaticObject.PackageQuantity) * 100);
      if (this.availableInvoicesPercentage > 100 )
        this.availableInvoicesPercentage = 100;
    }

    
    this.companyDashboardStaticObject.TipoSoggetto = company.TipoSoggetto == null? 0: company.TipoSoggetto;    
    this.companyDashboardStaticObject.isNamirialPayActive = company.isNamirialPayActive;
;

  }


  /**
   * Viene settato il JSON della lingua corrente alla LOGIN
   * @returns string
   */
  static setI18N(i18nJson: any) {
    this.I18N_JSON = i18nJson;

    let encodedI18NJson: string = btoa(JSON.stringify(this.I18N_JSON));
    localStorage.setItem(LOCAL_STORAGE_i18nJSON_NAME, encodedI18NJson);
  }

  /**
   * Se presente nel LOCALSTORAGE, viene recuperato il JSON e viene restituito, altrimenti viene restituito il JSON di default italiano
   * @returns string
   */
  static getI18nJson(): any {

    if (this.I18N_JSON == null || this.I18N_JSON == undefined) {
      let encodedI18NJson: string = localStorage.getItem(LOCAL_STORAGE_i18nJSON_NAME);
      if (encodedI18NJson) {
        let decodedI18NJson = JSON.parse(atob(encodedI18NJson));
        this.setI18N(decodedI18NJson);
      } else {
        this.I18N_JSON = "i18n_fr";
      }
    }

    return this.I18N_JSON;
  }


  /**
   * Viene settata la lingua selezionata alla LOGINF
   * @returns string
   */
  static setSelectedLanguage(selectedLanguage: any) {
    this.selectedLanguage = selectedLanguage;

    let encodedLanguageJson: string = btoa(JSON.stringify(this.selectedLanguage));
    localStorage.setItem(SELECTED_LANGUAGE_JSON, encodedLanguageJson);
  }


  /**
   * Se presente nel LOCALSTORAGE, viene recuperata la lingua corrente e viene restituita, altrimenti viene restituita di default l'IT
   * @returns string
   */
  static getSelectedLanguage(): any {

    if (this.selectedLanguage == null || this.selectedLanguage == undefined) {
      let encodedLanguageJson: string = localStorage.getItem(SELECTED_LANGUAGE_JSON);
      if (encodedLanguageJson) {
        let decodedLanguageJson = JSON.parse(atob(encodedLanguageJson));
        this.setSelectedLanguage(decodedLanguageJson);
      } else {
        this.selectedLanguage = "fr";
      }
    }

    return this.selectedLanguage;
  }
static getSelectedLanguageLongString(): any {
    return this.selectedLanguage + "-" + this.selectedLanguage.toUpperCase();
  }


  /**
   * Secondo l'algoritmo qui descritto:
   * viene restituito l'ID della company corretta
   */
  static getUsedCompany(): number {
    //Se è presente il currentManagedCompany, vince su tutto
    if (this.currentManagedCompany != null) {
      return this.currentManagedCompany.ID;
    } else if (this.getCurrentCompany() != null) {
      return this.getCurrentCompany().ID;
    } else {
      GlobalService._authService = InjectorInstance.get<AuthService>(AuthService);
      let currentUser = GlobalService._authService.getCurrentUser();
      //Nel caso di token scaduto viene svuotato lo User e andrebbe in errore, perciò prevedo che possa essere null
      return currentUser != null ? currentUser.FK_Company : null
    }
  }

  
  //Gestione del menù globale
  static async globalManageCompany(element): Promise<boolean> {
    let _checkMaganeCompanyPermission: boolean = true;

    if (element != null) {
      GlobalService._authService = InjectorInstance.get<AuthService>(AuthService);
      let currentUser = GlobalService._authService.getCurrentUser();
      GlobalService._userImpersonationService = InjectorInstance.get<UserImpersonationsService>(UserImpersonationsService);

      let _companyListDTO: CompanyListDTO[]  = await this._userImpersonationService.getCompaniesByUserGranting(currentUser.ID)
      _checkMaganeCompanyPermission = _companyListDTO.find(x => x.ID == element.ID) != null;
            
    }
    if (_checkMaganeCompanyPermission) {
      GlobalService.currentManagedCompany = element;
      GlobalService._menuService = InjectorInstance.get<MenuService>(MenuService);
      this._menuService.setMenu();

      // Al cambio gestione, faccio sempre il redirect alla dashboard
      GlobalService._router = InjectorInstance.get<Router>(Router);
      //TODO: per causa del reloadComponent in defaultLayout, all'exit della gestione rimane sul componente di partenza
      this._router.navigate(["/dashboard"]);
    }

    return _checkMaganeCompanyPermission; // Add this line to return a boolean value
  }



  /**
   * Effettua la chiamata al server per aggiornare la percentuale e il numero di fatture ancora disponibili
   */
  static updateAvailableInvoicesPercentage() {
    //Chiamata per recuperare la percentuale e il numero di fatture ancora disponibili
  }

  public static CompanyTypeFromAteco(CodiceAteco: string): AtecoCompanyType {
  
   let result = AtecoCompanyType.NOTHING;

   switch (CodiceAteco) {
    case "69.10.10":
      result = AtecoCompanyType.STUDILEGALI;
      break;    
    default:
      result = AtecoCompanyType.NOTHING;
  }

   return result; 
 }

public static CheckSpidFEService(): boolean {
  
  let next = true;  
  
  if (this.currentCompany.AuthFE == false) {
    next = false;
    DialogService.Confirm(this.currentCompany.CompanyType == CompanyTypeEnum.DESK ? this.translate.instant("DIALOGS.NAMIRIAL_ARCHIVE_MISSING")  :this.translate.instant("DIALOGS.SDI_AUTHENTICATION_MISSING"), () => {      
      if (this.currentCompany.CompanyType == CompanyTypeEnum.SHOP &&  !this.currentCompany.AuthSPID) {
        this.spidService.getSPIDUrlLogin();          
      } else {
        this.portaleFEService.PortaleFEAuth();
      }
    }, true);
  }
  
  return next;
}

public static CheckNamirialPay(): boolean {
  
  let next = true;  
  // Veriica se è stato effettuato l'onboarding di Namirial Pay, se non è stato fatto allora chiede di farlo  
  let numberPackage = this.currentCompany.ChildDetailProducts?.filter(p => p.ProductType === 1)?.length || 0;

  if (this.currentCompany.isNamirialPayActive <= 0 && numberPackage > 0) {
    next = false;
    DialogService.Confirm(this.translate.instant("DIALOGS.NAMIRIAL_PAY_ONBOARDING_MISSING"), () => {      
      DialogService.Info("Contact customer service to activate NamirialPay service");
    }, true);
  }
  
  return next;
}

}
